import isEmpty from 'lodash/isEmpty'

function computeVariantListWithoutOffer(product) {
  return (product.variants && product.variants.filter((variant) => variant.sellable && isEmpty(variant.offers))) || []
}

export { computeVariantListWithoutOffer }
